import * as S from './DownloadTemplate.styles'

interface Props {
  href: string
  title?: string
}

export default ({ href, title = 'Download Excel Modelo' }: Props) => (
  <a href={href}>
    <S.DownloadButton>{title}</S.DownloadButton>
  </a>
)
